import gql from 'graphql-tag';
import client from '@/options/apollo';

export default {
  queryMe() {
    return client.query({
      query: gql`
        query {
          result: me {
            currentAuthority: role
            avatar: avatar
            name: nickname
            unreadCount
            brandId
            id
            username
            accountType
            status
            phone
            serverRatio
            smId
            alipayUserId
            receiverPCT
            receiverType
            receiverAccount
            province
            city
            county
            createdAt
            remark
            restockType
            createType
            createUserName
            country
            brandId
            languageType
            timeZone
            crossTimezoneOffset
          }
        }
      `,
      variables: {},
      fetchPolicy: 'no-cache',
    });
  },
};
